<template>
  <!-- <StartupListPage :followed-only="true" /> -->
  <div>
    <StartupListTopNav />
    <ScrollTopButton />
    <div class="mt-6">
      Shortlists go here
    </div>
  </div>
</template>

<script>
import StartupListPage from 'modules/startup-list/StartupListPage.vue'
import StartupListTopNav from 'modules/startup-list/StartupListTopNav.vue'

export default {
  components: {
    StartupListPage,
    StartupListTopNav,
  },
}
</script>
